import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getSalesSettlementDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SALES_SETTLEMENT_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.SALES_SETTLEMENT_DETAILS_FAILURE });
        return error;
    }
}

export function* getOpenInvoiceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            skip: params.skip,
            type: actions.OPEN_INVOICE_DETAILS_SUCCESS,
            data: response?.data
        });
    } catch (error) {
        yield put({ type: actions.OPEN_INVOICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getOpenPaymentDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            skip: params.skip,
            type: actions.OPEN_PAYMENT_DETAILS_SUCCESS,
            data: response?.data
        });
    } catch (error) {
        yield put({ type: actions.OPEN_PAYMENT_DETAILS_FAILURE });
        return error;
    }
}

export function* getCloseInvoiceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.CLOSE_INVOICE_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.CLOSE_INVOICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getClosePaymentDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.CLOSE_PAYMENT_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.CLOSE_PAYMENT_DETAILS_FAILURE });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_REPORT_DETAILS_SUCCESS,
    });
}


export default function* salesSettlementSaga() {
    yield all([
        takeEvery(actions.SALES_SETTLEMENT_DETAILS_START, getSalesSettlementDetails),
        takeEvery(actions.OPEN_INVOICE_DETAILS_START, getOpenInvoiceDetails),
        takeEvery(actions.OPEN_PAYMENT_DETAILS_START, getOpenPaymentDetails),
        takeEvery(actions.CLOSE_INVOICE_DETAILS_START, getCloseInvoiceDetails),
        takeEvery(actions.CLOSE_PAYMENT_DETAILS_START, getClosePaymentDetails),
        takeEvery(actions.CLEAR_REPORT_DETAILS_START, getClearDetails)
    ]);
}